export const SET_SITE_INFO_TITLE = 'SET_SITE_INFO_TITLE'
export const SET_SITE_INFO_DESCRIPTION = 'SET_SITE_INFO_DESCRIPTION'
export const ADD_ALERT = 'ADD_ALERT'
export const REMOVE_ALERT_BY_URL = 'REMOVE_ALERT_BY_URL'
export const EMPTY_ALERTS = 'EMPTY_ALERTS'
export const UPDATE_USER_INFO = 'UPDATE_FOND'
